import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import api from '../utils/api';
import { LogOut, Bell, Calendar } from 'lucide-react';
import UserAvatar from './common/UserAvatar';
import PerfilModal from './PerfilModal';


const MobileLayout = ({ user, onLogout, onUserUpdate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [novasDemandas, setNovasDemandas] = useState(0);
  const [notificacoesNaoLidas, setNotificacoesNaoLidas] = useState(0);
  const [perfilOpen, setPerfilOpen] = useState(false);

  useEffect(() => {
    fetchContador();
    fetchNotificacoes();
    const interval = setInterval(() => {
      fetchContador();
      fetchNotificacoes();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  // Refresh badge imediatamente ao voltar da tela de notificações
  useEffect(() => {
    if (location.pathname !== '/notificacoes') {
      fetchNotificacoes();
    }
  }, [location.pathname]);

  const fetchContador = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/mobile/contador');
      setNovasDemandas(response.data.novas_demandas || 0);
    } catch (error) {
      console.error('Erro ao buscar contadores:', error);
    }
  };

  const fetchNotificacoes = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/mobile/notificacoes');
      setNotificacoesNaoLidas(response.data.nao_lidas || 0);
    } catch (error) {
      console.error('Erro ao buscar notificações:', error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header Mobile Fixo */}
      <header className="bg-primary text-white px-4 py-3 flex items-center justify-between sticky top-0 z-50 shadow-lg">
        <div className="flex items-center gap-3">
          <UserAvatar
            user={user}
            size={32}
            fallbackClassName="bg-secondary text-primary"
            onClick={() => setPerfilOpen(true)}
            title="Meu perfil"
          />
          <div>
            <p className="font-medium text-sm">{user.name}</p>
            <p className="text-xs text-white/70">Colaborador</p>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <button
            onClick={onLogout}
            className="p-2 hover:bg-white/20 rounded-lg transition-colors"
            title="Sair"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </header>

      {/* Conteúdo */}
      <main className="flex-1 pb-20">
        <Outlet />
      </main>

      {/* Bottom Navigation — z-40 para não cobrir os modais z-50 das telas do colaborador */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 flex justify-around py-2 z-40">
        <button
          onClick={() => navigate('/minha-programacao')}
          className={`flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-all ${
            location.pathname === '/minha-programacao' 
              ? 'text-primary bg-slate-100' 
              : 'text-slate-500'
          }`}
        >
          <div className="relative">
            <Calendar className="w-6 h-6" />
            {novasDemandas > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-2xs w-4 h-4 rounded-full flex items-center justify-center font-bold">
                {novasDemandas}
              </span>
            )}
          </div>
          <span className="text-xs font-medium">Programação</span>
        </button>
        
        <button
          onClick={() => navigate('/notificacoes')}
          className={`flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-all ${
            location.pathname === '/notificacoes' 
              ? 'text-primary bg-slate-100' 
              : 'text-slate-500'
          }`}
        >
          <div className="relative">
            <Bell className="w-6 h-6" />
            {notificacoesNaoLidas > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-2xs w-4 h-4 rounded-full flex items-center justify-center font-bold">
                {notificacoesNaoLidas}
              </span>
            )}
          </div>
          <span className="text-xs font-medium">Notificações</span>
        </button>
      </nav>

      <PerfilModal open={perfilOpen} onClose={() => setPerfilOpen(false)} user={user} onUpdated={onUserUpdate} />
    </div>
  );
};

export default MobileLayout;
